import classNames from 'classnames';
import DeleteIcon from 'material-ui-icons/Delete';
import IconButton from 'material-ui/IconButton';
import { withStyles } from 'material-ui/styles';
import { lighten } from 'material-ui/styles/colorManipulator';
import Toolbar from 'material-ui/Toolbar';
import Tooltip from 'material-ui/Tooltip';
import Typography from 'material-ui/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import { translate } from 'react-i18next';
import Button from 'material-ui/Button';

const toolbarStyles = theme => ({
    root: {
        paddingRight: theme.spacing.unit,
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.secondary,
                backgroundColor: theme.palette.secondary.dark,
            },
    spacer: {
        flex: '1 1 100%',
    },
    actions: {
        color: theme.palette.text.secondary,
    },
    title: {
        flex: '0 0 auto',
    },
    tableTitle: {
        color: theme.palette.primary.main,
        fontSize: 24,
        fontWeight: 300
    }
});

class InvoicesTableToolbar extends React.Component {
    constructor(props) {
        super(props);
    }



    render() {
        const { numSelected, classes, anchorEl, t } = this.props;
        return (
            <Toolbar
                className={classNames(classes.root, {
                    [classes.highlight]: numSelected > 0,
                })}
            >
                <div className={classes.title}>
                    {numSelected > 0 ? (
                        <Typography color="inherit" variant="subheading">
                            {numSelected} selected
                        </Typography>
                    ) : (
                        <Typography className={classes.tableTitle}>
                            <strong>{t('PAGE_TITLES.Invoices')}</strong>
                        </Typography>
                    )}
                </div>
                <div className={classes.spacer} />
                <div className={classes.actions}>
                    {numSelected > 0 ? (
                        <Tooltip title="Delete">
                            <IconButton aria-label="Delete">
                                <DeleteIcon />
                            </IconButton>
                        </Tooltip>
                    ) : (
                        <div>
                        </div>
                    )}
                </div>
                <div style={{ display: 'inherit' }}>
                    <div className={classes.actions}>
                        <Button
                            aria-label="COMMON.EXPORT_AS_PDF"
                            variant="raised"
                            aria-owns={anchorEl ? 'download-menu' : null}
                            style={{ minWidth: 180 }}
                            aria-haspopup="true"
                            onClick={(event) => {
                                this.props.actionHandler('PDF');
                            }}
                        >
                            {t('COMMON.EXPORT_AS_PDF')}
                        </Button>
                    </div>
                    <div className={classes.spacer} style={{ marginLeft: '10px' }} />
                    <div>
                        <Button
                            className={classes.buttonXLS}
                            aria-label="COMMON.EXPORT_AS_XLS"
                            variant="raised"
                            aria-owns={anchorEl ? 'download-menu' : null}
                            style={{ minWidth: 180 }}
                            aria-haspopup="true"
                            onClick={(event) => {
                                this.props.actionHandler('XLS');
                            }}
                        >
                            {t('COMMON.EXPORT_AS_XLS')}
                        </Button>
                    </div>
                </div>
            </Toolbar>
        );
    }
}

InvoicesTableToolbar.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
};

export default translate('translations')(withStyles(toolbarStyles)(InvoicesTableToolbar));


// WEBPACK FOOTER //
// ./src/components/Invoices/Table/InvoicesTableToolbar.js